module.exports = __webpack_public_path__ + "img/bird-3-right.0cd28050.png";